class GoUpController {

    constructor() {

        this._goUpData = new GoUpData();

    }

    _enableHandlers() {

        $(window).on("resize.GoUpPosition", this._setPosition.bind(this));
        $(window).on("scroll.GoUp", this._manageGoUpButtonStatus.bind(this));
        $(".bf-go-up").on("click.goUp", this._goUp.bind(this));

    }

    _disableHandlers() {

        $(window).off("resize.GoUpPosition");
        $(window).off("scroll.GoUp");
        $(".bf-go-up").off("click.goUp");

    }

    _setStyle() {

        const $goUpButtonIcon = $("#go-up-canvas");
        const $goUpButton = $(".bf-go-up");

        tintImage($goUpButtonIcon.attr("id"), $goUpButtonIcon.attr("data-icon"), world.theme.color_1);
        $goUpButton.css("border", "2px solid #" + world.theme.color_1);

    }

    _setPosition() {

        const $goUpButton = $(".bf-go-up");
        const $appWrapper = $(".wrapper").last();
        const $window = $(window);
        const that = this;
        let rightScreenPosition = this._goUpData.getDefaultSeparation();

        if ($window.width() > $appWrapper.width()) {
            rightScreenPosition = (($window.width() - $appWrapper.width()) / 2) + this._goUpData.getDefaultSeparation();
        }

        $goUpButton.css("right", rightScreenPosition + "px");

    }

    _showButton() {

        function _onAnimationComplete() {
            $goUpButton.show();
        }

        const $goUpButton = $(".bf-go-up");

        $goUpButton.fadeTo(this._goUpData.getDefaultAnimationTime(), 1, _onAnimationComplete);
        this._goUpData.setVisible(true);

    }

    _hideButton() {

        function _onAnimationComplete() {
            $goUpButton.hide();
        }

        const $goUpButton = $(".bf-go-up");

        $goUpButton.fadeTo(this._goUpData.getDefaultAnimationTime(), 0, _onAnimationComplete);
        this._goUpData.setVisible(false);

    }

    _goUp() {
        window.scrollTo(0, 0);
    }

    _manageGoUpButtonStatus() {

        function _onTimeOut() {
            that._hideButton();
        }

        const $window = $(window)
        const that = this;

        if ($window.scrollTop() >= this._goUpData.getDefaultScrollHeight()) {

            clearTimeout(this._goUpData.getInactiveScroll());

            this._goUpData.setInactiveScroll(setTimeout(_onTimeOut, this._goUpData.getDefaultTimeToDissapear()));

            if (!this._goUpData.getIsVisible()) {
                this._showButton();
            }

        } else {

            if (this._goUpData.getIsVisible()) {
                this._hideButton();
            }

        }

    }

    initialize() {

        this._setStyle();
        this._setPosition();
        this._disableHandlers();
        this._enableHandlers();

    }

    stop() {
        this._disableHandlers();
    }

}